import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectAnalyticsOfferStatus, selectAnalyticsProduct } from '../../selectors/analytics';
import { selectIsInsufficientFunds } from '../../selectors/checkoutInfo';
import {
  selectAuctionPoints,
  selectBalance,
  selectCanPayByCard,
  selectIsAgencyBalanceVisible,
  selectIsMasterMoneySource,
  selectSubagentSpendLimit,
  selectIsSubagent,
} from '../../selectors/user';
import { selectIsSubagentLimitExceed } from '../../selectors/publishTerms';
import { selectCanFillBalance } from '../../selectors/balance';
import { openModal } from '../../utils/modals';
import { Device } from '../common/Device';
import { BalanceDesktop, BalanceMobile } from './components';
import { trackLegalDepositLinkClick, trackNaturalDepositLinkClick } from './tracking';
import { getBalanceString, getIsShowAgencyBalance, getPayUrl } from './utils';

export const BalanceContainer = () => {
  const balance = useSelector(selectBalance);
  const auctionPoints = useSelector(selectAuctionPoints);
  const canFillBalance = useSelector(selectCanFillBalance);
  const isMasterMoneySource = useSelector(selectIsMasterMoneySource);
  const subagentSpendLimit = useSelector(selectSubagentSpendLimit);
  const isSubagent = useSelector(selectIsSubagent);
  const isAgencyBalanceVisible = useSelector(selectIsAgencyBalanceVisible);
  const canPayByCard = useSelector(selectCanPayByCard);
  const isInsufficientFunds = useSelector(selectIsInsufficientFunds);
  const analyticsOfferStatus = useSelector(selectAnalyticsOfferStatus);
  const analyticsProduct = useSelector(selectAnalyticsProduct);
  const isSubagentLimitExceed = useSelector(selectIsSubagentLimitExceed);

  const isSubagentSpendLimit = !!subagentSpendLimit;

  const isShowAgencyBalance = getIsShowAgencyBalance({
    isMasterMoneySource,
    isSubagentSpendLimit,
    isAgencyBalanceVisible,
  });

  const balanceString = getBalanceString({ balance, auctionPoints, isShowAgencyBalance });

  const payUrl = getPayUrl({ isMasterMoneySource, canPayByCard });

  const handleDepositLinkClick = React.useCallback(() => {
    if (canPayByCard) {
      const source = isInsufficientFunds ? 'balance' : 'refill';

      trackNaturalDepositLinkClick({ analyticsOfferStatus, analyticsProduct });

      openModal('payByCard', { options: { source } });
    } else {
      trackLegalDepositLinkClick(analyticsOfferStatus);
    }
  }, [canPayByCard, isInsufficientFunds]);

  const props = {
    withMoneySource: isSubagent,
    showBalance: !isSubagentLimitExceed,
    // после выпила тогла в задаче CD-150645 убрать условие из handleDepositLinkClick
    withPay: canFillBalance,
    balanceString,
    payUrl,
    handleDepositLinkClick,
  };

  return <Device desktop={<BalanceDesktop {...props} />} mobile={<BalanceMobile {...props} />} />;
};
